export const notificationDetails: Record<string, { shortDesc: string, fullDesc: string }> = {
  DevStreamEventCameraBlockageInteriorTotal: {
    shortDesc: 'Interior camera was totally blocked',
    fullDesc: 'Interior camera was totally blocked',
  },
  DevStreamEventCameraBlockageInteriorPartial: {
    shortDesc: 'Interior camera was partially blocked',
    fullDesc: 'Interior camera was partially blocked',
  },
  DevStreamEventCameraBlockageExteriorTotal: {
    shortDesc: 'Exterior camera was totally blocked',
    fullDesc: 'Exterior camera was totally blocked',
  },
  DevStreamEventCameraBlockageExteriorPartial: {
    shortDesc: 'Exterior camera was partially blocked',
    fullDesc: 'Exterior camera was partially blocked',
  },
  RequestAvatarFail: {
    shortDesc: 'Driver avatar requesting was failed',
    fullDesc: 'Driver avatar requesting was failed',
  },
  RequestAvatarSuccess: {
    shortDesc: 'Driver avatar was received from device',
    fullDesc: 'Driver avatar was received from device',
  },
  TripUpsertStart: {
    shortDesc: 'New trip was started',
    fullDesc: 'New trip was started',
  },
  TripUpsertStop: {
    shortDesc: 'Existing trip was ended',
    fullDesc: 'Existing trip was ended',
  },
  UpdateConfigSuccess: {
    shortDesc: 'Setting was updated successfully',
    fullDesc: 'Setting was updated successfully',
  },
  UpdateConfigFailed: {
    shortDesc: 'Setting update failed',
    fullDesc: 'Setting update failed',
  },
  VideoUploadedSuccess: {
    shortDesc: 'Custom VoD uploaded successfully',
    fullDesc: 'Custom VoD uploaded successfully',
  },
  VideoUploadedPartialSuccess: {
    shortDesc: 'Partial VoD footage uploaded',
    fullDesc: 'Only part of the requested footage was available on the device.',
  },
  VideoQueuedOffline: {
    shortDesc: 'VoD request queued (device offline)',
    fullDesc: 'Device is offline. Available footage for the selected time could not be verified on the device. The request was queued and will upload when the device reconnects.',
  },
  VideoUploadedFail: {
    shortDesc: 'Custom VoD upload failed',
    fullDesc: 'Custom VoD upload failed',
  },
  VideoNotAvailableOnDevice: {
    shortDesc: 'VoD footage not available on device',
    fullDesc: 'No footage was available on the device for the requested time. Your VoD request could not be fulfilled.',
  },
  AlertVideoUploadedSuccess: {
    shortDesc: 'Alert video uploaded successfully',
    fullDesc: 'Alert video uploaded successfully',
  },
  AlertVideoUploadedFail: {
    shortDesc: 'Alert video upload failed',
    fullDesc: 'Alert video upload failed',
  },
  LearnFaceSuccess: {
    shortDesc: 'Facial recognition data obtained',
    fullDesc: 'Facial recognition data was obtained successfully.',
  },
  LearnFaceFail: {
    shortDesc: 'Facial recognition data obtainment failed',
    fullDesc: 'Facial recognition data obtainment failed.',
  },
  LearnFaceTimedOut: {
    shortDesc: 'Facial recognition data obtainment timed out',
    fullDesc: 'Facial recognition data obtainment timed out.',
  },
  IntersectionsDirectionLeft: {
    shortDesc: 'Vehicle left geofence area',
    fullDesc: 'Vehicle left geofence area',
  },
  IntersectionsDirectionEntered: {
    shortDesc: 'Vehicle entered geofence area',
    fullDesc: 'Vehicle entered geofence area',
  },
};

const CUSTOM_VOD_EVENT_NAMES = new Set([
  'VideoUploadedSuccess',
  'VideoUploadedFail',
  'VideoQueuedOffline',
  'VideoUploadedPartialSuccess',
  'VideoNotAvailableOnDevice',
]);

function inferCustomVoDEventName(
  eventName: string,
  message?: string | null,
): string {
  if (eventName !== 'VideoUploadedSuccess' || !message?.trim()) {
    return eventName;
  }

  const normalized = message.toLowerCase();

  if (
    normalized.includes('offline')
    && (normalized.includes('queued') || normalized.includes('cannot be verified'))
  ) {
    return 'VideoQueuedOffline';
  }

  if (
    normalized.includes('only ')
    && normalized.includes('available on the device')
  ) {
    return 'VideoUploadedPartialSuccess';
  }

  if (
    normalized.includes('no footage')
    || normalized.includes('not available')
    || normalized.includes('could not be fulfilled')
  ) {
    return 'VideoNotAvailableOnDevice';
  }

  return eventName;
}

export function getCustomVoDNotificationText(
  eventName: string,
  message?: string | null,
): string {
  if (message?.trim()) {
    return message;
  }

  const resolvedEventName = inferCustomVoDEventName(eventName, message);
  return notificationDetails[resolvedEventName]?.fullDesc
    ?? notificationDetails.VideoUploadedSuccess.fullDesc;
}

export function isCustomVoDNotification(eventName: string): boolean {
  return CUSTOM_VOD_EVENT_NAMES.has(eventName);
}
